import { Box } from "@mui/material";

export default function InsumosCardShell({ children, sx }) {
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: "neutral.300",
        borderRadius: "30px",
        boxShadow: "inset 0px 0px 4px rgba(117, 117, 138, 0.5)",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
